<template>
  <div id="demo-basic-card" class="manager-keyword" >
    <div id="dashboard-analytics"  style="margin-left: 5px;">
      <div class="vx-col w-full mb-2 full-view-vertical" style="margin-top:-24px">
        <div class="vx-row full-width" style="padding:0px 0px 0px 15px">
          <vx-card :headerPadding="true" slot="no-body" class="p-1">
            <div class="vx-row">
              <div class="vx-col w-full md:w-2/3">
                <div class="" style="float:left">
                  <span class="branding ml-6 mt-2" style="float:left"
                    >{{$t('managerKeyword.managerKeywordTitle')}}</span
                  >
                </div>
                <div class="pl-6 mt-4" style="float:left">
                  <vs-button
                    class="border-button text-size"
                    style="height:33px"
                    icon-pack="feather"
                    @click="openAddGroupTopic"
                    >{{$t('managerKeyword.addNewCampaign')}}</vs-button
                  >
                </div>
                <!-- <div class="pl-6 mt-2" style="float:left">
                  <vs-button
                    style="height:30px"
                    class="border-button"
                    type="border"
                    icon-pack="feather"
                    icon="icon-share-2"
                    >Chia sẻ</vs-button
                  >
                </div> -->
              </div>

              <!-- <div class="vx-col w-full md:w-1/3 mt-2">
                <div class="ml-8" style="float:right">
                  <vs-button
                    class="border-button"
                    icon-pack="feather"
                    icon="icon-refresh-cw"
                    @click="refreshData"
                    style="height:30px"
                    >Cập nhật</vs-button
                  >
                </div>
              </div> -->
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/12 w-full mt-4 pt-2 ml-4" v-for="item in optionGroupTopics">
                <span class="text-size">{{item.label}}: <b>{{responseData.filter(el => el.topicGroupId == item.value).length}}</b></span>
              </div>

              <div class="vx-col md:w-1/6 w-full mt-4 pt-2">
                <span class="text-size">{{$t('managerKeyword.otherTopics')}}: <b>{{countOther}}</b></span>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-row p-0 pl-4 mt-2 full-width">
          <vx-card>
            <div class="vx-row">
              <div class="mt-2 ml-4" style="float:left">
                <span class="text-size">{{$t('managerKeyword.combinedAction')}}:</span>
              </div>
              <div class="ml-6 md:w-1/6" style="float:left;min-width: 300px">
                <v-select class="text-size" v-model="mergeAction" :options="optionalMergeAction" @input="selectMergeAction" :placeholder="$t('managerKeyword.placeholderAction')"></v-select>
              </div>
            </div>
              <!-- các chủ đề -->
            <div class = "vx-row pl-4"  v-for="item in optionGroupTopics">
              <div class = "vx-col w-full">
                <div class = "vx-row" >
                  <div class="vx-row border-bottom-title pb-2 mt-10 w-full" >
                    <div class="md:w-1/2">
                      <div class="mt-2" style="float:left;width: 100px;overflow: hidden;text-overflow: ellipsis">
                        <span class="title-menu text-size" style="font-size:18px !important">{{item.label}}</span>
                      </div>
                      <div class="pl-6 mt-2" style="float:left">
                        <vs-button
                          class="border-button text-size"
                          style="height:33px"
                          icon-pack="feather"
                          icon="icon-edit-2"
                          @click="activePopupTopicGroup(item)"
                        >{{$t('managerKeyword.campaignUpdate')}}</vs-button
                        >
                      </div>
                      <div class="pl-6 mt-2" style="float:left">
                        <vs-button
                          class="border-button text-size"
                          style="height:33px"
                          icon-pack="feather"
                          icon="icon-trash-2"
                          @click="confirmRemoveTopicGroup(item)"
                        >{{$t('managerKeyword.deleteCampaign')}}</vs-button
                        >
                      </div>
                      <div class="pl-6 mt-2" style="float:left">
                        <vs-button
                          style="height:33px"
                          class="border-button text-size"
                          type="border"
                          icon-pack="feather"
                          icon="icon-share-2"
                          :title="$t('managerKeyword.titleShare')"
                          @click="openPopupShareTopicByGroupId(item)"
                        >{{$t('managerKeyword.share')}}</vs-button
                        >
                      </div>
                    </div>
                    <div class="pl-6 mt-2 md:w-1/2 pr-2" style="">
                      <vs-button
                        class="border-button text-size"
                        style="height:33px;float:right"
                        icon-pack="feather"
                        @click="activePopupOther(item)"
                      >{{$t('managerKeyword.addNewTopic')}}</vs-button>
                    </div>
                  </div>
            <!-- bảng thương hiệu tổ chức -->
                  <div class="vx-row w-full title-size">
                    <vs-table stripe :data="responseData" class="w-full" :noDataText="this.$t('noData')">
                      <template slot="thead" class="title-size ">
                        <vs-th class="vx-col md:w-1/4 w-full mt-2">
                          <vs-checkbox v-if="item.checkedAll" v-model="item.checkAllOri" style="float:left" @change="checkAll(item)"></vs-checkbox>{{$t('managerKeyword.topic')}}
                        </vs-th>
                        <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.keyword')}}</vs-th>
                        <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.informationResource')}}</vs-th>
                        <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.dateCreated')}}</vs-th>
                        <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.creator')}}</vs-th>
                        <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.share')}}</vs-th>
                        <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.action')}}</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :data="item" :key="index"
                               v-for="(item, index) in responseData.filter(el => el.topicGroupId == item.value)">
                          <vs-td :data="data[index].topicName" class="vx-col md:w-1/4 w-full mt-2">
                            <vs-checkbox v-if="!item.shareId" v-model="item.checked" style="float:left"></vs-checkbox>
                            <span class="color-col">
                              <b v-if="!item.shareId">{{ item.topicName }} </b>
                              <b v-else class="ml-10">{{ item.topicName }} </b>
                            </span>
                            <span style="color:red;font-size:12px" v-if="item.status == 0">({{$t('managerKeyword.notAcceptedYet')}})</span>
                            <span v-if="item.status != 0">{{
                                " (" + (item.topicRelationship == 0 ? $t('managerKeyword.your') : item.topicRelationship == 1 ? $t('managerKeyword.rival') : $t('managerKeyword.other')) + ")"
                              }}</span>
                          </vs-td>
                          <vs-td :data="data[index].keyword" class="vx-col md:w-1/6 w-full mt-2">
                            <span class="color-col" v-if="item.plus > 0">{{
                                item.keyword
                              }}, +{{ item.plus || 0 }}</span>
                            <span class="color-col" v-else>{{ item.keyword }}</span>
                          </vs-td>
                          <vs-td class="vx-col md:w-1/12 w-full mt-2">
                            <span class="color-col">{{$t('managerKeyword.all')}}</span>
                          </vs-td>
                          <vs-td :data="data[index].createdDate" class="vx-col md:w-1/12 w-full mt-2">
                            <span class="color-col">{{ item.createdDate }}</span>
                          </vs-td>
                          <vs-td :data="data[index].createdBy" class="vx-col md:w-1/6 w-full mt-2">
                            <div v-if="item.createdBy != null">
                      <span v-if="item.currentUserName != item.createdBy">
                        {{$t('managerKeyword.sharedBy')}}: &nbsp;
                      </span>
                              <span class="color-col">{{ item.createdBy }}</span>
                            </div>
                            <div v-else>
                              <span class="color-col">{{ item.createdBy || item.modifiedBy }}</span>
                            </div>
                          </vs-td>
                          <vs-td class="vx-col md:w-1/12 w-full mt-2" style="min-width:80px">
                            <feather-icon
                              class="ml-6"
                              v-if="item.status == undefined"
                              icon="Share2Icon"
                              style="vertical-align:middle;width:1rem"
                              :title="$t('managerKeyword.shareThisThread')"
                              @click="shareTopic(item)"
                            >
                            </feather-icon>
                            <feather-icon
                              v-if="item.status == 0"
                              class="ml-2"
                              icon="CheckIcon"
                              style="vertical-align:middle;width:1rem;color:green"
                              :title="$t('managerKeyword.accept')"
                              @click="addShareTopic(item)"
                            ></feather-icon>
                            <feather-icon
                              v-if="item.status == 0"
                              class="ml-2"
                              icon="XIcon"
                              style="vertical-align:middle;width:1rem;color:red"
                              @click="rejectShareTopic(item)"
                              :title="$t('managerKeyword.refuse')"
                            ></feather-icon>
                          </vs-td>
                          <vs-td class="vx-col md:w-1/6 w-full">
                            <feather-icon
                              v-if="item.status == undefined"
                              icon="Edit2Icon"
                              class="pb-2"
                              style="vertical-align:middle;width:1rem"
                              @click="editTopic(item)"
                              :title="$t('managerKeyword.changeTheme')">
                            </feather-icon>
                            <feather-icon
                              v-if=" item.status == undefined && (item.viewTopic == null || item.viewTopic == true)"
                              class="ml-6 pb-2"
                              icon="EyeIcon"
                              style="vertical-align:middle;width:1rem"
                              @click="viewTopic(item)"
                              :title="$t('managerKeyword.hideTopic')">{{ item.status + "abc" }}
                            </feather-icon>
                            <feather-icon
                              v-if="item.status == undefined && item.viewTopic == false"
                              class="ml-6 pb-2"
                              icon="EyeOffIcon"
                              style="vertical-align:middle;width:1rem"
                              @click="viewTopic(item)"
                              :title="$t('managerKeyword.showTopic')">
                            </feather-icon>
                            <feather-icon
                              v-if="item.status == undefined && !item.favourite"
                              class="ml-6 pb-2"
                              icon="StarIcon"
                              style="vertical-align:middle;width:1rem"
                              :title="$t('managerKeyword.bookmarkTopicsAsFavorites')"
                              @click="favourite(item)">
                            </feather-icon>
                            <feather-icon
                              class="ml-6 pb-2"
                              v-if="item.status == undefined && item.favourite"
                              icon="StarIcon"
                              style="vertical-align:middle;width:1rem;color:#ffb100"
                              :title="$t('managerKeyword.removeFavoriteTopic')"
                              @click="favourite(item)"></feather-icon>
                            <feather-icon
                              v-if="item.status == undefined"
                              class="ml-6 pb-2"
                              icon="XIcon"
                              style="vertical-align:middle;width:1rem"
                              @click="confirmDeleteRecord(item)"
                              :title="$t('managerKeyword.deleteTopic')">
                            </feather-icon>
                            <vs-dropdown title="Xem thêm" vs-custom-content vs-trigger-click class="cursor-pointer"
                                         v-if="item.status == undefined">
                              <vs-button class="btn-drop" type="flat" icon="more_horiz"
                                         style="color: #626262 !important;"></vs-button>
                              <vs-dropdown-menu class="vx-navbar-dropdown">
                                <ul style="min-width: 13rem">
                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                      @click="copyLink(item)">
                                    <feather-icon
                                      v-if="item.status == undefined"
                                      :data-url="item.topicName"
                                      icon="CopyIcon"
                                      style="vertical-align:middle;width:1rem"
                                      @click="copyLink(item)"
                                      :title="$t('managerKeyword.copyTheme')">
                                    </feather-icon>
                                    <span class="ml-4">{{$t('managerKeyword.copyTheme')}}</span>
                                  </li>
                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                      @click="openPopupTopicGroup(item)">
                                    <feather-icon
                                      v-if="item.status == undefined"
                                      icon="CornerRightUpIcon"
                                      :title="$t('managerKeyword.changeTheSubject')"
                                      style="vertical-align:middle;width:1rem"
                                      @click="openPopupTopicGroup(item)">
                                    </feather-icon>
                                    <span class="ml-4">{{$t('managerKeyword.changeTheSubject')}}</span>
                                  </li>
                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                      @click="allowNotify(item)">
                                    <feather-icon
                                      v-if=" item.status == undefined && (item.allowNotify == null || item.allowNotify == true)"
                                      icon="BellIcon"
                                      style="vertical-align:middle;width:1rem"
                                      @click="allowNotify(item)"
                                      :title="$t('managerKeyword.turnOffNoti')">
                                      {{ item.status + "abc" }}
                                    </feather-icon>
                                    <feather-icon
                                      v-if="item.status == undefined && item.allowNotify == false"
                                      icon="BellOffIcon"
                                      style="vertical-align:middle;width:1rem"
                                      @click="allowNotify(item)"
                                      :title="$t('managerKeyword.turnOnNoti')">
                                    </feather-icon>
                                    <span class="ml-4"
                                          v-if="item.status == undefined && (item.allowNotify == null || item.allowNotify == true)">{{$t('managerKeyword.turnOffNoti')}}</span>
                                    <span class="ml-4" v-if="item.status == undefined && item.allowNotify == false">{{$t('managerKeyword.turnOnNoti')}}</span>
                                  </li>

                                  <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                      @click="openPopupPriority(item)">
                                    <feather-icon
                                      v-if="item.status == undefined"
                                      icon="ToolIcon"
                                      :title="$t('managerKeyword.changeTheSubject')"
                                      style="vertical-align:middle;width:1rem"
                                      @click="openPopupPriority(item)">
                                    </feather-icon>
                                    <span class="ml-4">{{$t('managerKeyword.priority')}}</span>
                                  </li>

                                </ul>
                              </vs-dropdown-menu>
                            </vs-dropdown>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
              </div>
              </div>
            </div>
            <!-- các chủ đề khacs -->
            <div class = "vx-col w-full pl-4">
              <div class = "vx-row" >
                <div class="vx-row border-bottom-title pb-2 mt-10 w-full">
                  <div class="md:w-1/2">
                    <div class="mt-2" style="float:left">
                      <span class="title-menu" >{{$t('managerKeyword.otherTopics')}}</span>
                    </div>
                    <div class="pl-6 mt-2" style="float:left">
                      <vs-button
                        style="height:33px"
                        class="border-button text-size"
                        type="border"
                        icon-pack="feather"
                        icon="icon-share-2"
                        :title="$t('managerKeyword.titleShare')"
                        @click="openPopupShareTopicByGroupId(item)"
                      >{{$t('managerKeyword.share')}}</vs-button
                      >
                    </div>
                  </div>
                  <div class="pl-6 mt-2 md:w-1/2 pr-2" style="float:right">
                    <vs-button
                      class="border-button text-size"
                      style="height:33px;float:right"
                      icon-pack="feather"
                      @click="activePopupOther2"
                      >{{$t('managerKeyword.addNewTopic')}}</vs-button>
                  </div>
                </div>
                <div class="vx-row w-full title-size">
                <vs-table stripe :data="responseData" class="w-full" :noDataText="this.$t('noData')" >
                  <template slot="thead">
                    <vs-th class="vx-col md:w-1/4 w-full mt-2">
                      <vs-checkbox v-if="checkedSelected" v-model="checkAllOther" style="float:left" @change="selectAllOther"></vs-checkbox>
                      {{$t('managerKeyword.topic')}}
                    </vs-th>
                    <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.keyword')}}</vs-th>
                    <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.informationResource')}}</vs-th>
                    <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.dateCreated')}}</vs-th>
                    <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.creator')}}</vs-th>
                    <vs-th class="vx-col md:w-1/12 w-full mt-2">{{$t('managerKeyword.share')}}</vs-th>
                    <vs-th class="vx-col md:w-1/6 w-full mt-2">{{$t('managerKeyword.action')}}</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :data="item" :key="index" v-for="(item, index) in responseData.filter(el => el.isOther)">
                      <vs-td :data="data[index].topicName" class="vx-col md:w-1/4 w-full mt-2">
                        <vs-checkbox v-if="!item.shareId" v-model="item.checked" style="float:left"></vs-checkbox>
                        <span class="color-col">
                        <b v-if="!item.shareId">{{ item.topicName }} </b>
                        <b v-else class="ml-10">{{ item.topicName }} </b>
                      </span>
                        <span style="color:red;font-size:12px" v-if="item.status == 0">({{$t('managerKeyword.notAcceptedYet')}})</span>
                        <span v-if="item.status != 0">{{" (" + (item.topicRelationship == 0 ? $t('managerKeyword.your') : item.topicRelationship == 1 ? $t('managerKeyword.rival') : $t('managerKeyword.other')) + ")"}}</span>
                      </vs-td>
                      <vs-td :data="data[index].keyword" class="vx-col md:w-1/6 w-full mt-2">
                        <span class="color-col" v-if="item.plus > 0">{{ item.keyword }}, +{{item.plus || 0}}</span>
                        <span class="color-col" v-else>{{ item.keyword }}</span>
                      </vs-td>
                      <vs-td class="vx-col md:w-1/12 w-full mt-2">
                        <span class="color-col">{{$t('managerKeyword.all')}}</span>
                      </vs-td>
                      <vs-td :data="data[index].displayCreatedDate" class="vx-col md:w-1/12 w-full mt-2">
                        <span class="color-col">{{ item.displayCreatedDate }}</span>
                      </vs-td>
                      <vs-td :data="data[index].createdBy" class="vx-col md:w-1/6 w-full mt-2">
                        <div v-if="item.createdBy != null">
                        <span v-if="item.currentUserName != item.createdBy">
                          {{$t('managerKeyword.sharedBy')}}: &nbsp;
                        </span>
                          <span class="color-col">{{ item.createdBy }}</span>
                        </div>
                        <div v-else>
                          <span class="color-col">{{ item.createdBy || item.modifiedBy }}</span>
                        </div>
                      </vs-td>
                      <vs-td class="vx-col md:w-1/12 w-full mt-2" style="min-width:80px">
                        <feather-icon
                          class="ml-6"
                          v-if="item.status == undefined"
                          icon="Share2Icon"
                          style="vertical-align:middle;width:1rem"
                          :title="$t('managerKeyword.shareThisThread')"
                          @click="shareTopic(item)"
                        >
                        </feather-icon>
                        <feather-icon
                          v-if="item.status == 0"
                          class="ml-2"
                          icon="CheckIcon"
                          style="vertical-align:middle;width:1rem;color:green"
                          :title="$t('managerKeyword.accept')"
                          @click="addShareTopic(item)"
                        ></feather-icon>
                        <feather-icon
                          v-if="item.status == 0"
                          class="ml-2"
                          icon="XIcon"
                          style="vertical-align:middle;width:1rem;color:red"
                          @click="rejectShareTopic(item)"
                          :title="$t('managerKeyword.refuse')"
                        ></feather-icon>
                      </vs-td>
                      <vs-td class="vx-col md:w-1/6 w-full">
                        <feather-icon
                          v-if="item.status == undefined"
                          icon="Edit2Icon"
                          class="pb-2"
                          style="vertical-align:middle;width:1rem"
                          @click="editTopic(item)"
                          :title="$t('managerKeyword.changeTheme')">
                        </feather-icon>
                        <feather-icon
                          v-if=" item.status == undefined && (item.viewTopic == null || item.viewTopic == true)"
                          class="ml-6 pb-2"
                          icon="EyeIcon"
                          style="vertical-align:middle;width:1rem"
                          @click="viewTopic(item)"
                          :title="$t('managerKeyword.hideTopic')">{{ item.status + "abc" }}
                        </feather-icon>
                        <feather-icon
                          v-if="item.status == undefined && item.viewTopic == false"
                          class="ml-6 pb-2"
                          icon="EyeOffIcon"
                          style="vertical-align:middle;width:1rem"
                          @click="viewTopic(item)"
                          :title="$t('managerKeyword.showTopic')">
                        </feather-icon>
                        <feather-icon
                          v-if="item.status == undefined && !item.favourite"
                          class="ml-6 pb-2"
                          icon="StarIcon"
                          style="vertical-align:middle;width:1rem"
                          :title="$t('managerKeyword.bookmarkTopicsAsFavorites')"
                          @click="favourite(item)">
                        </feather-icon>
                        <feather-icon
                          class="ml-6 pb-2"
                          v-if="item.status == undefined && item.favourite"
                          icon="StarIcon"
                          style="vertical-align:middle;width:1rem;color:#ffb100"
                          :title="$t('managerKeyword.removeFavoriteTopic')"
                          @click="favourite(item)"></feather-icon>
                        <feather-icon
                          v-if="item.status == undefined"
                          class="ml-6 pb-2"
                          icon="XIcon"
                          style="vertical-align:middle;width:1rem"
                          @click="confirmDeleteRecord(item)"
                          :title="$t('managerKeyword.deleteTopic')">
                        </feather-icon>
                        <vs-dropdown title="Xem thêm" vs-custom-content vs-trigger-click class="cursor-pointer"
                                     v-if="item.status == undefined">
                          <vs-button class="btn-drop" type="flat" icon="more_horiz"
                                     style="color: #626262 !important;"></vs-button>
                          <vs-dropdown-menu class="vx-navbar-dropdown">
                            <ul style="min-width: 13rem">
                              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                  @click="copyLink(item)">
                                <feather-icon
                                  v-if="item.status == undefined"
                                  :data-url="item.topicName"
                                  icon="CopyIcon"
                                  style="vertical-align:middle;width:1rem"
                                  @click="copyLink(item)"
                                  :title="$t('managerKeyword.copyTheme')">
                                </feather-icon>
                                <span class="ml-4">{{$t('managerKeyword.copyTheme')}}</span>
                              </li>
                              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                  @click="openPopupTopicGroup(item)">
                                <feather-icon
                                  v-if="item.status == undefined"
                                  icon="CornerRightUpIcon"
                                  :title="$t('managerKeyword.changeTheSubject')"
                                  style="vertical-align:middle;width:1rem"
                                  @click="openPopupTopicGroup(item)">
                                </feather-icon>
                                <span class="ml-4">{{$t('managerKeyword.changeTheSubject')}}</span>
                              </li>
                              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                  @click="allowNotify(item)">
                                <feather-icon
                                  v-if=" item.status == undefined && (item.allowNotify == null || item.allowNotify == true)"
                                  icon="BellIcon"
                                  style="vertical-align:middle;width:1rem"
                                  @click="allowNotify(item)"
                                  :title="$t('managerKeyword.turnOffNoti')">
                                  {{ item.status + "abc" }}
                                </feather-icon>
                                <feather-icon
                                  v-if="item.status == undefined && item.allowNotify == false"
                                  icon="BellOffIcon"
                                  style="vertical-align:middle;width:1rem"
                                  @click="allowNotify(item)"
                                  :title="$t('managerKeyword.turnOnNoti')">
                                </feather-icon>
                                <span class="ml-4"
                                      v-if="item.status == undefined && (item.allowNotify == null || item.allowNotify == true)">{{$t('managerKeyword.turnOffNoti')}}</span>
                                <span class="ml-4" v-if="item.status == undefined && item.allowNotify == false">{{$t('managerKeyword.turnOnNoti')}}</span>
                              </li>

                               <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                  @click="openPopupPriority(item)">
                                <feather-icon
                                  v-if="item.status == undefined"
                                  icon="ToolIcon"
                                  :title="$t('managerKeyword.changeTheSubject')"
                                  style="vertical-align:middle;width:1rem"
                                  @click="openPopupPriority(item)">
                                </feather-icon>
                                <span class="ml-4">{{$t('managerKeyword.priority')}}</span>
                              </li>
                            </ul>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
               </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>

    <vs-popup :title="isUpdateGroup ? $t('managerKeyword.updateTitle') : $t('managerKeyword.addTitle')" :active.sync="popupActive">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vs-input
            v-model="topicGroupName"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            :label="$t('managerKeyword.nameCampaign')"
            name="topicGroupName"
          ></vs-input>
          <span class="text-danger text-sm">{{
            errors.first("topicGroupName")
          }}</span>
        </div>
      </div>
      <div class="vx-row" style="text-align:center">
        <div class="vx-col w-full mt-4">
          <span>{{$t('managerKeyword.spanPopup')}}.</span>
        </div>
      </div>
      <div class="vx-row center-content mt-2">
        <vs-button
          class="border-radius"
          icon-pack="feather"
          icon="icon-X"
          :disabled="!validateForm"
          @click="addGroupTopic"
          >
          {{`${isUpdateGroup ? $t('managerKeyword.btnUpdate'): $t('managerKeyword.btnCreate')}`}}
          </vs-button
        >
      </div>
      <div class="vx-row center-content mt-2">
        <vs-button
          class="border-radius"
          type="border"
          icon-pack="feather"
          icon="icon-X"
          @click="closePopup"
          >{{$t('managerKeyword.close')}}</vs-button
        >
      </div>
    </vs-popup>

     <!-- mức độ uu tiên -->
    <vs-popup :title="$t('managerKeyword.priority')" :active.sync="activePriority">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <vs-input min= '0'  max ='50' v-model="topic.priority" type= "number"></vs-input>
        </div>
      </div>

      <div class="vx-row mt-20">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="updatePriority">{{$t('managerKeyword.update')}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="activePriority = false">{{$t('managerKeyword.back')}}
                </vs-button>
              </div>
            </div>
          </div>
    </vs-popup>

    <!-- di chuyển các lựa chọn -->
    <vs-popup :title="$t('managerKeyword.switchGroupsTopic')" :active.sync="activePopupTopicGroups">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <v-select v-model="selectedTopicGroup" :options ="optionGroupTopics" :placeholder="$t('managerKeyword.placeSelect')"></v-select>
        </div>
      </div>

      <div class="vx-row mt-20">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="directionTopicGroup">{{$t('managerKeyword.btnUpdate')}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="activePopupTopicGroups = false">{{$t('managerKeyword.back')}}
                </vs-button>
              </div>
            </div>
          </div>
    </vs-popup>

    <!-- Thêm sửa chủ đề -->
    <vs-popup :title="$t('managerKeyword.topic')" :active.sync="activePopupTopic">
      <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0 mb-2"
                           :settings="settings" style="max-height: 36rem" >
        <div class="mr-4">
          <div class="vx-row">
            <div class="vx-col w-full mt">
              <span class="title-topic-popup">{{$t('managerKeyword.topicName')}}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-1">
              <span>{{$t('managerKeyword.spanText')}}</span>
              <vs-input class="mt-1" v-model="topic.topicName"></vs-input>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-10">
              <span>{{$t('managerKeyword.topicTo')}}:</span>
              <vs-radio v-model="radio" vs-value="0" class="ml-4 text-checkbox">{{$t('managerKeyword.you')}}</vs-radio>
              <vs-radio v-model="radio" vs-value="1" class="ml-4 text-checkbox">{{$t('managerKeyword.rival')}}</vs-radio>
              <vs-radio v-model="radio" vs-value="2" class="ml-4 text-checkbox">{{$t('managerKeyword.other')}}</vs-radio>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full mt-2">
              <span class="title-topic-popup">{{$t('managerKeyword.keyword')}}</span>
            </div>
            <div class="vx-col w-full mt-2">
              <span>{{$t('managerKeyword.spanText1')}}:</span>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/2 w-full mt-2 title-keyword"><label>{{$t('managerKeyword.mainKey')}}</label></div>
            <div class="vx-col md:w-1/2 w-full mt-2 title-keyword"><label style="margin-left:-1.2rem">{{$t('managerKeyword.subKey')}}</label></div>
          </div>
          <div class="vx-row new-keyword-area" v-for="(item,index) in keywords">
            <div class="vx-col md:w-1/2 w-full mt-2">
                  <vs-input
                    id ="keyword"
                    style = "height: 30px;margin-top: 1.2px"
                    data-vv-validate-on="input"
                    type="text"
                    :placeholder="$t('managerKeyword.placeInput')"
                    name="keyword"
                    v-model="item.keyword"
                    autocomplete="off"
                    v-on:keydown="checkKeypress($event,index)"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{
                    errors.first("keyword")
                  }}</span>
              </div>

              <div class="vx-col md:w-1/2 w-full keyword-depend mt-2">
                  <div class="vx-row ti-input">
                    <vue-tags-input style = "width:80%; "
                    id ="keywordDepend"
                    placeholder = ""
                    @onblur="onBlur"
                    v-model="item.tag"
                    :tags=item.action
                    @tags-changed="newTags => item.action = newTags"
                    @before-adding-tag="checkTag"
                    allow-edit-tags
                    v-validate="'max:50'"
                    name="keywordDependent"
                    @input="checkKeypressDepend($event,index)"
                  />
                  <span class="text-danger text-sm">{{
                    errors.first("keywordDependent")
                  }}</span>

                  <div class="vx-col" style="line-height: 39px;width:20%">
                    <feather-icon icon="PlusIcon" style = "vertical-align: middle" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" :title="$t('managerKeyword.addKey')" @click="addNewRecord(index + 1)"/>
                    <feather-icon style="margin-left: 10px; vertical-align: middle" icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" :title="$t('managerKeyword.deleKey')" @click="confirmDeleteRecords(index)"/>
                  </div>
                  </div>
                </div>
          </div>

          <div class="vx-row mt-2">
            <div class="vx-col w-full mt-2">
              <span class="title-keyword">{{$t('managerKeyword.removeKey')}}</span>
            </div>

            <div class="vx-col w-full mt-2">
              <span class="">{{$t('managerKeyword.spanText2')}} <b style="color:red">{{$t('managerKeyword.extrude')}}</b> {{$t('managerKeyword.spanText3')}}</span>
            </div>
          </div>

          <div class="vx-row drop-keyword" >
            <div class="vx-col w-full"  v-for="(item) in tagsListAction" >
              <div class="vx-col col-12 w-full mt-1">
                <vue-tags-input style = "margin-top: 0px !important;max-width: 100% !important;"
                v-validate="'max:255'"
                placeholder=""
                v-model="item.tag2"
                :tags=item.action
                @tags-changed="newTags => item.action = newTags"
                @before-adding-tag="checkTag"
                allow-edit-tags
                @input="checkKeypressDrop($event)"
                />
              </div>
            </div>
          </div>
          <div class="vx-row ml-1 mt-6" >
            {{ `${$t('managerKeyword.dataLast30Days')}: ${dataPreview.dataLast30Days === null ? $t('managerKeyword.notEstimate') : (dataPreview.dataLast30Days + " " + $t('managerKeyword.posts'))}` }}
          </div>
          <div class="vx-row ml-1" >
            {{ `${$t('managerKeyword.dataLast7Days')}: ${dataPreview.dataLast7Days === null ? $t('managerKeyword.notEstimate') : (dataPreview.dataLast7Days + " " + $t('managerKeyword.posts'))}` }}
          </div>
          <div class="vx-row ml-1" >
            {{ `${$t('managerKeyword.dataLast3Days')}: ${dataPreview.dataLast3Days === null ? $t('managerKeyword.notEstimate') : (dataPreview.dataLast3Days + " " + $t('managerKeyword.posts'))}` }}
          </div>
          <div class="vx-row ml-1" >
            {{ `${$t('managerKeyword.avgTime')}: ${dataPreview.avgTime}` }}
          </div>
        </div>
      </VuePerfectScrollbar>
      <div class="vx-row" style="heigh:10%;border-top: 1px solid #ccc">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
            <vs-button icon-pack="feather" icon="icon-X" class="ml-auto mt-2 border-radius" type="border" @click="activePopupTopic = false">{{ this.$t('managerKeyword.close')}}
            </vs-button>
            <vs-button icon-pack="feather" icon="icon" class="ml-4 mt-2 border-radius" @click="previewData" :disabled="!validateForm">{{$t('managerKeyword.btnPreview')}}
            </vs-button>
            <vs-button icon-pack="feather" icon="icon" class="ml-4 mt-2 border-radius" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
              $t('managerKeyword.btnUpdate'): $t('managerKeyword.btnCreate')}`}}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="$t('managerKeyword.shareKey')" :active.sync="activePopupShareTopic">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <vs-input
          v-model="emailShare"
          v-validate ="'required|email'"
          data-vv-validate-on="blur"
          name="email"
          :label="$t('managerKeyword.emailShare')"
          @input="checkInput"
          ></vs-input>
          <span class="text-danger text-sm">
                {{errors.first("email")}}
          </span>
        </div>
      </div>

      <div class="vx-row mt-20">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 border-radius" icon-pack="feather" icon="icon" @click="choseShareTopic" :disabled="!validateForm"> {{$t('managerKeyword.share')}}
                </vs-button>
                <vs-button class="ml-4 mt-2 border-radius" icon-pack="feather" icon="icon" type="border" @click="activePopupShareTopic = false">{{$t('managerKeyword.close')}}
                </vs-button>
              </div>
            </div>
          </div>
    </vs-popup>
  </div>
</template>
<script>
import DateRangePicker from "@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import vSelect from "vue-select";
import moment from "moment";
import VueTagsInput from '@johmun/vue-tags-input';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    DateRangePicker,
    vSelect,
    moment,
    VueTagsInput,
    VuePerfectScrollbar
  },
  data() {
    return {
      textTitleCamp:null,
      topicId:null,
      checkAllOri:false,
      checkAllOther:false,
      checked:false,
      countBranding: null,
      countProductBranding: null,
      countPersonalBranding: null,
      countOther: null,
      topicGroupdId: null,
      topicGroupName: null,
      popupActive: false,
      topics: [],
      optionalBranding: [],
      optionalProductBranding: [],
      optionalPersonalBrandig: [],
      optionalOtherBranding: [],
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 6);
          date.setHours(0, 0, 0);
          return date;
        })()
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .30,
        suppressScrollX: true
      },
      optionalMergeAction:[
        {label:'Chia sẻ các lựa chọn', value:0},
        {label:'Sao chép các lựa chọn', value:1},
        {label:'Di chuyển các lựa chọn', value: 2},
        {label:'So sánh các lựa chọn', value:4},
        {label:'Xóa các lựa chọn', value:3}
      ],
      valueMergeAction:null,
      optionGroupTopics:[],
      topicGroupId:null,
      activePopupTopicGroups:false,
      activePopupTopic:false,
      activePopupShareTopic:false,
      activePriority:false,
      emailShare:null,
      dataTopic:{},
      responseData:[],
      userId:null,
      isUpdateGroup:false,
      topic:{
        id:null,
        topicName: null,
        topicGroupId: null,
        excludeKeyword:null,
        articleSource:[],
        topicRelationShip:null,
        favourite:null,
        priority: null
      },
      keywords: [{
          keyword:"",
          action: []
      }],
      tagsListAction:[{
          action:[]
        }],
        isUpdate:false,
        valueCheckbox:[],

      //selected
      selectedPersonal:false,
      selectedCompetitor:false,
      selectedOther:false,
      valueSelected:null,
      radio:null,
      statusShare:null,

      registerData:{},
      payloadPopupShare:false,
      shareByTopicId:false,
      dataCopy:null,
      shareTopicInTable:false,
      checkedSelected:false,
      dataPreview: {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: ""
      }
    };
  },
  watch:{

  },
  computed: {
    state(){
      return Boolean(this.valueCheckedRadio);
    },
    selectedTopicGroup: {
      get(){
        let object = this.optionGroupTopics.find(el => el.value ===  this.topicGroupdId);
        if(!object) return null;
        return {
          label:object.label,
          value:object.value
        }
      },
      set(object){
        this.topicGroupdId = object.value
      }
    },
    validateForm() {
      return !this.errors.any();
    },
    mergeAction:{
      get:function(){
        let object=  this.optionalMergeAction.find(el => el.value === this.valueMergeAction);
        if(!object) return null;
        return{
          label:object.label,
          value:object.value
        }
      },
      set:function(object){
        this.valueMergeAction = object ? object.value : null
      }
    }
  },

  methods: {
    onBlur:function(){
    },
    checkboxCombinedAction : function () {
      this.optionalMergeAction[0].label = this.$t('managerKeyword.boxShare')
      this.optionalMergeAction[1].label = this.$t('managerKeyword.boxCopy')
      this.optionalMergeAction[2].label = this.$t('managerKeyword.boxMove')
      this.optionalMergeAction[3].label = this.$t('managerKeyword.boxCompare')
      this.optionalMergeAction[4].label = this.$t('managerKeyword.boxDelete')
      this.dataPreview.avgTime = this.$t('managerKeyword.notEstimate')
    },
    checkInput: function(){
      document.getElementsByClassName('text-danger text-sm')[0].style.display = "block"
    },
    checkKeypressDrop: function(event){
      if(event.includes(",")){
        document.getElementsByClassName('drop-keyword')[0].getElementsByTagName('input')[0]
        .dispatchEvent(new KeyboardEvent('keydown',{'keyCode':'13'}))
      }
    },
    checkKeypressDepend: function(event,index){
      if(event.includes(",")){
          document.getElementsByClassName("new-keyword-area")[index].getElementsByClassName('keyword-depend')[0]
          .getElementsByTagName("input")[0].dispatchEvent(new KeyboardEvent('keydown',{'keyCode':'13'}))
      }
    },
    checkKeypress: function(event,index){
      const value = event.keyCode;
      if(value == 188 || value == 13){
        this.addNewRecord(index + 1);
        setTimeout(() =>{
          document.getElementsByClassName("new-keyword-area")[index + 1].getElementsByTagName("input")[0].focus()
        },200)
      }
      // if(value == 13){
      //   document.getElementsByClassName("new-keyword-area")[0].getElementsByClassName('keyword-depend')[0].getElementsByTagName('input')[0].focus();
      // }

    },
    onChangeKeyValue: function(){
    },
    viewTopic: function(event){
      this.$vs.loading();
      this.$business.post(`topic/hidden-topic/${event.id}`).then(() =>{
        this.$vs.loading.close();
        this.initScreen();
        return this.$vs.notify({
          text:` ${ event.viewTopic == false ? this.$t('managerKeyword.show') : this.$t('managerKeyword.hide')} ` + ` ${this.$t('managerKeyword.textTheme')} `,
          icon:'icon-alert-circle',
          iconPack:'feather',
          color:'primary'
        })
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    })},
    allowNotify: function(event){
      this.$vs.loading();
      const payload = {
        id:event.id
      }
      this.$business.post(`topic/allow-notify`, payload).then(() =>{
        this.$vs.loading.close();
        this.initScreen();
        return this.$vs.notify({
          text:`${ event.allowNotify == false ? this.$t('managerKeyword.turnOn') : this.$t('managerKeyword.turnOf')} ` + `${this.$t('managerKeyword.textNotifi')}`,
          icon:'icon-alert-circle',
          iconPack:'feather',
          color:'primary'
        })
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    rejectShareTopic: function(event){
      this.$vs.loading();
      const payload ={
        id:event.shareId
      }
      this.$business.post(`/share-topic/cancel-request`, payload).then(() =>{
        this.$vs.loading.close();
        this.initScreen();
        this.$vs.notify({
          text: this.$t('managerKeyword.textRefuse') `${event.topicName}`,
          iconPack:'feather',
          icon:'icon-alert',
          color:'primary'
        })
      }).catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
    choseShareTopic:function(){
      this.$vs.loading();
      if(this.valueMergeAction || this.valueMergeAction === 0){
        this.registerShareList();
        this.$vs.loading.close();
      }
      else if(this.shareByTopicId){
        this.shareTopicByGroupId();
        this.$vs.loading.close();
      }
      else if(this.shareTopicInTable){
        const payload ={
        email: this.emailShare,
        topicGroupId: this.registerData.topicGroupdId,
        topicId:this.registerData.id
      }
      this.$business.post(`/share-topic/register-share-topic`,payload).then(() =>{
        this.activePopupShareTopic = false;
        this.emailShare = null;
        this.$vs.loading.close()
        return this.$vs.notify({
          text:this.$t('managerKeyword.textShare') `${this.registerData.topicName}`,
          iconPack:'feather',
          icon:'alert-icon',
          color:'primary'
        })
      }).catch((err)=>{
        this.$vs.loading.close()
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      }
    },
    shareTopic: function(event){
      this.valueMergeAction = null;
      this.registerData = event;
      this.shareTopicInTable = true;
      this.activePopupShareTopic = true;
      this.emailShare = null;
    },
    addShareTopic: function(event){
      this.$vs.loading();
      const payload ={
        id:event.shareId
      }
      this.$business.post(`/share-topic/accept-request`, payload).then(() =>{
        this.$vs.loading.close();
        this.initScreen();
        this.$vs.notify({
          text:this.$t('managerKeyword.textAdd') + ` ${event.topicName}`,
          iconPack:'feather',
          icon:'icon-alert',
          color:'primary'
        })
      })
    },
    async saveChanges(evt) {
        evt.preventDefault();
        const keyword = this.keywords.map(key =>{
          return key.keyword;
        })
        for(let i = 0;i<keyword.length;i++){
          if(!keyword[i]){
            return this.$vs.notify({
            text: this.$t('managerKeyword.textKeyword'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          }
        }
        // let validate = await this.$validator.validateAll();
        // if (!this.validateForm) return;
        // if(!validate) return;
        // let isCheckDuplicateKeyword = this.checkIfDuplicateExists(this.keywords.map(x => x.keyword));
        // if(isCheckDuplicateKeyword) {
        //   return this.$vs.notify({
        //     text: " Từ khóa chính phải là duy nhất.",
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'danger'
        //   });
        // }

        // const result = await this.$validator.validateAll();
        // if (!result) return;
        if(this.keywords){
          this.keywords = this.keywords.map(keyword => {
          let action = [];
          if(keyword.action) {
            action = keyword.action.map(action => {return action.text;}).filter(item => item);
          }
          return {
            keyword: keyword.keyword,
            action: action
          }
        });
        }
        this.valueCheckbox = [];
        this.valueCheckbox.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113);

        let checked = false;
        if(checked){
            return this.$vs.notify({
              text: this.$t('managerKeyword.textKeyword2'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
        }
        if (this.valueCheckbox.length == 0 ){
          return this.$vs.notify({
            text: this.$t('managerKeyword.textSource'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        if(this.selectedCompetitor){
          this.valueSelected = 0;
        }
        if(this.selectedPersonal){
          this.valueSelected = 1;
        }
        if(this.selectedOther){
          this.valueSelected = 2;
        }
        if (!this.topic.topicName) {
          return this.$vs.notify({
            text: this.$t('managerKeyword.textTheme2'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        if(this.isUpdate){
          this.topic.id = this.topicId;
        }
        else{
          this.topic.id= null;
        }
        this.topic.articleSource = this.valueCheckbox;
        this.topic.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
        this.topic.keywords = this.keywords;
        this.topic.topicGroupId = this.topicGroupdId;
        this.topic.topicRelationship = this.radio;
        this.topic.favourite = false;
        let path = this.isUpdate ? ('/topic/update') : '/topic/create';
        this.$vs.loading();
        this.$business.post(path, this.topic).then(() => {

          this.$vs.loading.close();
          this.$vs.notify({
            color: 'primary',
            text: ` ${this.isUpdate ? this.$t('managerKeyword.btnUpdate') : this.$t('managerKeyword.add')} ` + ` ${this.$t('managerKeyword.textAdd')} ` + `${this.topic.topicName}` ,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.activePopupTopic= false;
          // this.topic ={
          //   topicName: null,
          //   topicGroupId: null,
          //   excludeKeyword:null,
          //   articleSource:[]
          // }
          this.initScreen();
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      },
      checkIfDuplicateExists(w){
        return new Set(w).size !== w.length
      },
      confirmDeleteRecords(index) {
      this.activePopupTopic = false;
        if(this.keywords.length == 1) {
          return this.$vs.notify({
            text: this.$t('managerKeyword.textTheme3'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
        this.keywordId = index;
        this.deleteRecordPlus();
    },
    async previewData(evt) {
      evt.preventDefault();
      let keyword = this.keywords.map(key =>{
        return key.keyword;
      })
      for(let i = 0;i<keyword.length;i++){
        if(!keyword[i]){
          return this.$vs.notify({
          text: this.$t('managerKeyword.textKeyword'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
        }
      }
      if(keyword){
        keyword = this.keywords.map(keyword => {
        let action = [];
        if(keyword.action) {
          action = keyword.action.map(action => {return action.text;}).filter(item => item);
        }
        return {
          keyword: keyword.keyword,
          action: action
        }
      });
      }
      let valueCheckbox = [];
      valueCheckbox.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113);

      let checked = false;
      if(checked){
          return this.$vs.notify({
            text: this.$t('managerKeyword.textKeyword2'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
      }
      let condition = JSON.parse(JSON.stringify(this.topic));
      condition.articleSource = valueCheckbox;
      condition.excludeKeyword = this.tagsListAction[0].action.map(item => item.text);
      condition.keywords = keyword;
      condition.topicGroupId = this.topicGroupdId;
      condition.topicRelationship = this.radio;
      condition.favourite = false;
      this.$vs.loading();

      this.$processor.post("/search/preview-data", condition).then((response) => {
        this.dataPreview = response.data;
        let data30DaysAvg = this.dataPreview.dataLast30Days / 30 / 1440;
        let data7DaysAvg = this.dataPreview.dataLast7Days / 7 / 1440;
        let data3DaysAvg = this.dataPreview.dataLast3Days / 3 / 1440;
        let dataYesterdayAvg = this.dataPreview.dataYesterday / 1 / 1440;
        let avg = 1/((data30DaysAvg + data7DaysAvg + data3DaysAvg + dataYesterdayAvg)/4);
        if (isNaN(avg)) avg = 0;
        this.dataPreview.avgTime = avg == 0 ? this.$t('managerKeyword.cannotEstimate') : avg > 720 ? this.$t('managerKeyword.cannotEstimate') : ((avg.toFixed(0) < 15 ? " < 15 " : avg.toFixed(0)) + " " + this.$t('managerKeyword.minute'))
        this.$vs.loading.close();
      }).catch(() => {
        this.$vs.loading.close();
      });
    },
    addNewRecord(index) {
        this.keywords.splice(index, 0, {})
    },
    checkTag(obj) {
      this.textInput = obj;
      const text = obj.tag.text.split(',')[0];
      obj.tag.text = text;
      if(text.length > 20){
        return this.$vs.notify({
          text:this.$t('managerKeyword.textLength'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'danger'
        })
      }
        obj.addTag();
    },
    saveChangeTopic: function(){
      this.activePopupTopic = true;
    },
    activePopupProduct: function(){
      this.activePopupTopic = true;
    },
    activePopupPersonal: function(){
      this.activePopupTopic = true;
    },
    activePopupTopicGroup: function(event){
      if(event){
        this.topicGroupdId = event.value
      }
      this.$business.get(`topic-group/find-by-id/` + this.topicGroupdId).then((res) =>{
        const data = res.data;
        this.topicGroupName = data.groupName;
        this.topicGroupdId = data.id;
        this.userId = data.userId;
        this.isUpdateGroup = true;
        this.popupActive = true;
      })
    },
    confirmRemoveTopicGroup: function(event){
      if(event){
        this.topicGroupdId = event.value;
      }
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('managerKeyword.titleCampaign'),
          text: this.$t('managerKeyword.textDeleteCampaign') +  ` ${event.label}?`,
          accept: this.removeTopicGroup,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
    },
    removeTopicGroup: function(){
      this.$business.post(`topic-group/delete/${this.topicGroupdId}`).then(() =>{
        this.initScreen();
        return this.$vs.notify({
          text: this.$t('managerKeyword.textDeleteSuccess'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'primary'
        })
      })
    },
    activePopupOther: function(event){
      if(event.value != undefined){
        this.topicGroupdId =event.value;
      }
      this.isUpdate = false;
      this.activePopupTopic = true;
      this.topic={
        topicName: null,
        topicGroupId: null,
        excludeKeyword:[],
        articleSource:[],
        topicRelationship:null
      }
      this.dataPreview = {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: this.$t('managerKeyword.notEstimate')
      }
      this.radio = null;

      if(this.keywords.length > 1){
        this.keywords.forEach(el => {
        el.keyword  = null;
        for(let i =0; i< this.keywords.length;i++){
          this.keywords.splice(i,1);
        }
      })
      }

      this.keywords.forEach(el =>{
        if(el.keyword){
          el.keyword = null;
        }
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
      this.tagsListAction.forEach(el => {
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
    },
    activePopupOther2: function(){
      this.isUpdate = false;
      this.activePopupTopic = true;
      this.topic={
        topicName: null,
        topicGroupId: null,
        excludeKeyword:[],
        articleSource:[],
        topicRelationship:null
      }
      this.dataPreview = {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: this.$t('managerKeyword.notEstimate')
      }
      this.radio = null;
      if(this.keywords.length > 1){
        this.keywords.forEach(el => {
        el.keyword  = null;
        for(let i =0; i< this.keywords.length;i++){
          this.keywords.splice(i,1);
        }
      })
      }

      this.keywords.forEach(el =>{
        if(el.keyword){
          el.keyword = null;
        }
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
      this.tagsListAction.forEach(el => {
        if(el.action && el.action.length > 0){
          el.action = el.action.forEach(() => {return null})
        }

      })
    },
    openPopupPriority: function(item){
      this.activePriority = true;
      this.topic.id = item.id;
      this.topic.priority = item.priority;
    },
    openPopupTopicGroup: function(item){
      this.dataTopic = item;
      this.activePopupTopicGroups = true;
      this.topicId= item.id;
    },
    changeTopicGroup: function(data){
       const payload ={
        topicGroupId:this.topicGroupdId,
        userId:this.userId,
        id: data.id,
        favourite:data.favourite,
        keywords:data.keywords,
        articleSource:data.articleSource,
        excludeKeyword:data.excludeKeyword,
        topicName: data.topicName
      }
      this.$business.post('/topic/update', payload).then(() =>{
        this.activePopupTopicGroups = false;
        this.$vs.loading.close();
        this.initScreen();
        return this.$vs.notify({
          color: 'primary',
          text: this.$t('managerKeyword.textMoveSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      })
    },
    updatePriority: function(){
      if (this.topic.priority > 50){
        this.$vs.notify({
          text: this.$t('managerKeyword.priorityLevelReject'),
          icon:'icon-alert',
          iconPack: 'feahter',
          color:'danger'
        })
        return false;
      }
      const payload = {
        id : this.topic.id,
        priority: parseInt(this.topic.priority )
      }
      this.$vs.loading();
      this.$business.post('/topic/priority', payload).then(() =>{
        this.$vs.loading.close();
        this.activePriority = false;
        this.initScreen();
        this.$vs.notify({
          text: this.$t('managerKeyword.priorityLevelSuccess'),
          icon:'icon-alert',
          iconPack: 'feather',
          color: 'primary'
        })
      })
    },
    directionTopicGroup: function(){
      this.$vs.loading();
      this.activePopupTopicGroups= true;
      let userInfo =  localStorage.getItem('userInfo');
      let parseUserInfo = JSON.parse(userInfo);
      this.userId = parseUserInfo.id;
      const data = this.responseData.filter(el => el.checked == true);
      if(this.valueMergeAction){
        data.forEach(el =>  this.changeTopicGroup(el));
      }
      else{
        this.changeTopicGroup(this.dataTopic)
      }
    },
    selectMergeAction: function(){
      if (this.valueMergeAction == null) {
        return;
      }
      if (!this.responseData.filter(el => el.checked == true).length) {
        return this.$vs.notify({
            text: this.$t('managerKeyword.textTheme4'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      }
      if(this.valueMergeAction == 0){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('managerKeyword.titlePooledShare'),
          text: this.$t('managerKeyword.textPooledShare'),
          accept: this.openPopupShare,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }
      if(this.valueMergeAction == 1){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('managerKeyword.titlePooledCopy'),
          text: this.$t('managerKeyword.textPooledCopy'),
          accept: this.saveCopyData,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }
      if(this.valueMergeAction == 2){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('managerKeyword.titlePooledMove'),
          text: this.$t('managerKeyword.textPooledMove'),
          accept: this.directionMergeAction,
          acceptText:this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }
      if(this.valueMergeAction == 3){
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title:  this.$t('managerKeyword.titlePooledDelete'),
          text:  this.$t('managerKeyword.textPooledDelete'),
          accept: this.deleteByListTopicId,
          acceptText:  this.$t('managerKeyword.acceptText'),
          cancelText:  this.$t('managerKeyword.cancelText')
        })
      }
      if(this.valueMergeAction == 4){
        this.$vs.dialog({
          type:'confirm',
          color:'primary',
          title: this.$t('managerKeyword.titlePooledCompare'),
          text: this.$t('managerKeyword.textPooledCompare'),
          accept: this.compareTopic,
          acceptText: this.$t('managerKeyword.acceptText'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      }
    },
    compareTopic: function(){
      const dataSelected = this.responseData.filter(el => el.checked == true);
      const arrId=[];
      dataSelected.forEach(el =>{
        arrId.push(el.id)
      })
      window.open("/user/compare-branding" + "?data=" + arrId, '_blank');
    },
    beforeDestroy: function () {
    this.$eventBus.$off('dataSelected');
    },
    directionMergeAction: function(){
      this.activePopupTopicGroups= true;
    },
    saveCopyData: function(){
      this.responseData.filter(el => el.checked == true).forEach(data =>{
          this.copyData(data);
      });
    },
    openPopupShare(){
      this.activePopupShareTopic = true;
      this.payloadPopupShare = true;
      this.emailShare = null;
      this.shareByTopicId = false;
      document.getElementsByClassName('text-danger text-sm')[0].style.display = "none"
    },
    openPopupShareTopicByGroupId: function(item){
      this.activePopupShareTopic = true;
      this.emailShare = null;
      this.topicGroupdId = item.value;
      this.shareByTopicId = true;
      this.payloadPopupShare = false;
    },
    shareTopicByGroupId: function(){
      if(this.emailShare){
        const payload = [];
      this.responseData.filter(el => el.topicGroupId == this.topicGroupdId).forEach(value =>{
        value.email = this.emailShare;
        value.topicId = value.id;
        payload.push(value);
      })

      this.$business.post(`/share-topic/register-list-share`,payload).then(() =>{
        this.activePopupShareTopic = false;
        this.emailShare = null
        this.initScreen();
         return this.$vs.notify({
          text:this.$t('managerKeyword.textShareThemeSuccess'),
          iconPack:'feather',
          icon:'icon-alert',
          color:'primary'
        })
      })
      .catch((err) =>{
         return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
      }
    },
    registerShareList: function(){
      const payload =[];
      if(this.emailShare){
        this.responseData.filter(el => el.checked).forEach(value =>{
        value.email = this.emailShare;
        value.topicId= value.id;
        payload.push(value);
      })

      this.$business.post(`/share-topic/register-list-share`,payload).then(() =>{
        this.activePopupShareTopic = false;
        this.emailShare = null
        this.initScreen();
         return this.$vs.notify({
          text:this.$t('managerKeyword.textShareThemeSuccess'),
          iconPack:'feather',
          icon:'icon-alert',
          color:'primary'
        })
      })
      .catch((err) =>{
        this.$vs.loading.close();
         return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
      }
    },
    deleteByListTopicId:function(){
      let undo = false;
      const time = 10000;
      this.$toasted.show(`${this.$t('managerKeyword.deleted')}`,{
        action:{
          text : this.$t('managerKeyword.cancelText'),
          onClick : (e, toastObject) => {
            undo = true;
              toastObject.goAway(0);
          }
      },
      duration:10000,
      className:'notify-toast',
      position:'bottom-right'
      })
        setTimeout(()=>{
          if(!undo){
            const request=[];
            this.responseData.filter(el => el.checked).forEach(value =>{
              request.push(value.id);
            })
            this.$business.post(`/topic/delete-by-id`, request).then(() =>{
              this.initScreen();
              return this.$vs.notify({
                text: this.$t('managerKeyword.textDele'),
                iconPack:'feather',
                icon:'icon-alert',
                color:'primary'
              })
            }).catch((err) =>{
              return this.$vs.notify({
                  text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                });
            })
          }
      }, time)
    },
    confirmFavourite(item) {
      this.topicId= item.id;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('managerKeyword.titleDelete'),
          text: `${this.$t('managerKeyword.textFavorite')}` + ` "${item.topicName}"`,
          accept: this.favourite,
          acceptText: this.$t('managerKeyword.delete'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
    },
    showUpdateSuccess(event) {
      const isFavourite = event.favourite;
      this.$store.commit('UPDATE_USER_SUCCESS', true);
      this.$vs.notify({
        color: 'primary',
        text: ` ${isFavourite ? this.$t('managerKeyword.cancelText') : this.$t('managerKeyword.btnUpdate')} ` + ` ${this.$t('managerKeyword.textFavourite')}`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    favourite:function(event) {
        this.$vs.loading();
        let id = event.id;
        if(event.favourite){
          id = 0
        }
        this.$business.post(`/topic/favourite/${id}`).then(() => {
          this.$vs.loading.close();
          this.initScreen();
          return this.showUpdateSuccess(event);
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    checkAll: function(item){
      const data = this.responseData.filter(el => el.topicGroupId == item.value && !el.shareId);
      data.forEach(el =>{
        el.checked = 0
      });
      if(item.checkAllOri){
        data.forEach(el =>{
          el.checked = 1
        })
      }
    },
    selectAllOther: function(){
      const data = this.responseData.filter(el => el.isOther && !el.shareId);
      data.forEach(el =>{
        el.checked = false
      });
      if(this.checkAllOther){
        data.forEach(el =>{
          el.checked = true
        })
      }
    },
    showDeleteSuccess() {
        this.$store.commit('UPDATE_USER_SUCCESS', true);
        this.$vs.notify({
          color: 'primary',
          text: this.$t('managerKeyword.textDeleSuccess'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
    },
    confirmDeleteRecord(item) {
      this.topicId= item.id;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('managerKeyword.titleDelete'),
          text: this.$t('managerKeyword.textDelete') + `"${item.topicName}"`,
          accept: this.deleteRecord,
          acceptText:this.$t('managerKeyword.delete'),
          cancelText: this.$t('managerKeyword.cancelText')
        })
      },
      deleteRecordPlus() {
        this.activePopupTopic = true;
        this.keywords.splice(this.keywordId, 1)
      },
      deleteRecord() {
        let undo = false;
        const time = 10000;
        this.$toasted.show(`${this.$t('managerKeyword.deleted')}`,{
          action:{
            text : this.$t('managerKeyword.cancelText'),
            onClick : (e, toastObject) => {
              undo = true;
                toastObject.goAway(0);
            }
        },
        duration:10000,
        className:'notify-toast',
        position:'bottom-right'
        })
          setTimeout(()=>{
            if(!undo){
              this.$vs.loading();
              this.$business.post(`/topic/delete/${this.topicId}`).then(() => {
                this.$vs.loading.close();
                this.initScreen();
                // return this.showDeleteSuccess();
              }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                  text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                });
              });
            }
        }, time)

    },
    editTopic: function(item){
      this.activePopupTopic = true;
      this.topicId = item.id;
      this.topicGroupdId = item.topicGroupId;
      this.dataPreview = {
        dataLast30Days:null,
        dataLast7Days:null,
        dataLast3Days:null,
        dataYesterday:null,
        dataToday:null,
        avgTime: this.$t('managerKeyword.notEstimate')
      }
      if (this.topicId) {
        this.$vs.loading();
        this.$business.get('/topic/find-by-id/' + this.topicId).then((response) => {
          this.topic.topicName = response.data.topicName;
          this.topic.topicGroupId = response.data.topicGroupId;
          let keywordsRes = response.data.keywords;
          let excludeKeyword = response.data.excludeKeyword;
          let articleSource = response.data.articleSource;
          this.isUpdate=true;
          this.radio = response.data.topicRelationship
          keywordsRes.forEach(keyword => {
            keyword.action = keyword.action.map(action => {
              return {
                text: action,
                tiClasses: ["ti-valid"]
              }
            })
          });
          this.topic.articleSource = articleSource;
          this.tagsListAction = [{"action": excludeKeyword.map (item => {
            return {
                  text:item,
                  tiClasses:['ti-valid']
                }
          })}] ;
          this.keywords = keywordsRes;
          this.isUpdate = true;
          this.$vs.loading.close();
          this.topic.topicRelationShip = response.data.topicRelationship;
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    copyData:function(event){
      const payload ={
        topicGroupId:event.topicGroupId,
        userId:event.userId,
        favourite:event.favourite,
        keywords:event.keywords,
        articleSource:event.articleSource,
        excludeKeyword:event.excludeKeyword,
        topicName: event.topicName  + '(copy)'
      }
      this.$business.post('/topic/create',payload).then(() =>{
        this.$vs.loading.close();
        this.initScreen();
        return this.$vs.notify({
          text: this.$t('managerKeyword.textCopy') `${event.topicName}`,
          iconPack:'feather',
          icon:'icon-alert',
          color:'primary'
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    copyLink: function(event) {
      this.$vs.loading();
      this.copyData(event);
    },
    getTopicByOrganizationBranding: function() {
      const result = this.optionGroupTopics;
      this.$vs.loading();
      const payload = {};
      this.$business.post(`topic/find-by-conditions`, payload).then(res => {
        this.$business.post(`share-topic/get-all-share`,{}).then((response) => {
          let currentUserName = JSON.parse(localStorage.userInfo).email
          const dataShare = response.data;
          const dataShareTopic = response.data;
            if(dataShare.status == 0){
              dataShareTopic.forEach(key =>{
                key.status = dataShare.status;
              })
            }
          const data = [...res.data, ...dataShareTopic.filter(item => item.status == 0 || item.status == 1)];
          this.statusShare = response.data.status;
          this.countBranding = this.optionalBranding.length;
          this.countProductBranding = this.optionalProductBranding.length;
          this.countPersonalBranding = this.optionalPersonalBrandig.length;
          this.$vs.loading.close();
          this.responseData = data;
          data.forEach(el => {
            el.currentUserName = currentUserName;
            if(el.keywords.length > 2){
              el.plus = el.keywords.length - 2;
              el.keyword = el.keywords.map(k => k.keyword).slice(0,2).join(", ");
            }
            else{
              el.keyword = el.keywords.map(k => k.keyword).join(", ");
            }
            if(el.topicName.length > 25){
              el.topicName = el.topicName.slice(0,25) + '...';
            }
            el.displayCreatedDate = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
            el.checked = false;
            if (!this.optionGroupTopics.find(item => item.value == el.topicGroupId)) {
              el.isOther = true
            } else {
              el.isOther = false
            }
          });
          this.topics = data;
          const countOther= data.filter(item => item.isOther);
          this.countOther = countOther.length;
          let resultFilter = [];
          let checkedShareId = [];
          result.forEach(el => {
            resultFilter = data.filter(topic => el.value == topic.topicGroupId)
            checkedShareId = resultFilter.filter(filter => !filter.shareId);
            // let resultFilterOther = data.filter(topic => el.value != topic.topicGroupId)
            // let checkedShareOther = resultFilterOther.filter(filter => !filter.shareId);
            if(checkedShareId.length > 0){
              el.checkedAll = true;
            }
            if(el.isOther){
              this.checkedSelected = true;
            }
        })
      })
      .catch(() => {
        return this.$vs.loading.close();
      });
    })
    },
    addGroupTopic: function() {
      this.isUpdate = false;
      // this.topic={
      //   topicName: null,
      //   topicGroupId: null,
      //   excludeKeyword:[],
      //   articleSource:[],
      //   topicGroupId:null,
      //   topicRelationShip:null
      // }
      // this.keywords = []
      if (!this.topicGroupName || this.topicGroupName.trim().length == 0 ){
        return this.$vs.notify({
            text:
              this.$t('managerKeyword.textCampaign'),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
      }
      if (this.topicGroupName.trim().length > 100 ){
        return this.$vs.notify({
            text:
              this.$t('managerKeyword.textCampaign2'),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
      }

      this.$vs.loading();
      const payloadCreate = {
        groupName: this.topicGroupName
      };
      const payloadUpdate ={
        id:this.topicGroupdId,
        userId:this.userId,
        groupName: this.topicGroupName
      }
      const payload = this.isUpdateGroup ? payloadUpdate : payloadCreate;
      const path = this.isUpdateGroup ? '/topic-group/update' : '/topic-group/create';
      this.$business
        .post(path, payload)
        .then(async () => {
          this.initScreen();
          this.popupActive = false;
          this.$vs.loading.close();
          return this.$vs.notify({
            text: ` ${this.isUpdateGroup ?  this.$t('managerKeyword.btnUpdate') :  this.$t('managerKeyword.btnCreate')} `  ` ${this.$t('managerKeyword.textCampaign3')}`,
            iconPack: "feather",
            icon: "icon-alert",
            color: "primary"
          });
        })
        .catch(err => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    closePopup: function() {
      this.popupActive = false;
      this.topic = {
        topicName: null,
        topicGroupId: null,
        excludeKeyword:[],
        articleSource:[],
        topicRelationShip:null
      }
      this.keywords =[]
    },
    openAddGroupTopic: function() {
      this.popupActive = true;
      this.topicGroupName = null;
      this.isUpdateGroup = false;
      this.errors.clear()
    },
    getTopic() {
      let conditions = {};
      this.$business
        .post("/topic/find-by-conditions", conditions)
        .then(topics => {
          this.$business.post(`share-topic/get-all-share`,{}).then((res) => {
            this.topics = topics.data;
            this.topics.forEach(item => {
              if (item.favourite) {
                this.searchByTopic(item);
              }
            });

          this.initScreen();
          this.topics.unshift({ topicName: "Tất cả", id: null });

          const statusShare=  res.data.topic;
          statusShare.forEach(value =>{
            this.topics.push(value);
          })
        }).catch()

        })
        .catch();
    },
    getTopicGroups: function(){
      return new Promise((resolve,reject) =>{
        this.$business.post('/topic-group/find-by-conditions',{}).then((res) =>{
        this.optionGroupTopics = res.data;
        if(this.optionGroupTopics.length > 0){
          this.optionGroupTopics = this.optionGroupTopics.map(el =>{
            if(el.groupName && el.groupName.length > 25){
              el.groupName = el.groupName.slice(0,25) + '...';
            }
            return {
              label:el.groupName,
              value:el.id
            }
          });
        }
      }).catch(() => reject())
      })
    },
    initScreen() {
      this.getTopicGroups().then(() =>{
        this.getTopicByOrganizationBranding()
      });
      this.dateRange.startDate = new Date(
        this.dateRange.startDate.setHours(0, 0, 0)
      );
      this.dateRange.endDate = new Date(
        this.dateRange.endDate.setHours(23, 59, 59)
      );
      this.from = this.dateRange.startDate;
      this.to = this.dateRange.endDate;
      this.refreshData();


    },
    getShareTopic: function() {

    },
    refreshData: function() {}
  },
  async created() {
    this.initScreen();
    this.$eventBus.$on('i18n', () => {
      this.checkboxCombinedAction();
    })
    this.checkboxCombinedAction()
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss";
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
.branding {
  text-align: left;
  justify-content: center;
  font-size: 2.2rem;
  font-weight: bold;
}
.title-menu {
  font-size: 1.5rem;
  font-weight: bold;
}
.border-button {
  border-radius: 20px;
}
.border-bottom-title {
  border-bottom: 1px solid #c2c6dc;
}
.color-col {
  color: #277df6;
}
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input {
  max-height: 36.5px;
}
.border-radius {
  border-radius: 20px;
  height: 30px;
}
.center-content {
  justify-content: center;
}
.vs-popup{
  width: 60rem !important;
}
.title-topic-popup{
  font-size: 25px;
  font-weight: bold;
  color: #277df6
}
.title-keyword{
  font-size: 14px;
  font-weight: bold;
  color: #277df6
}
.text-checkbox{
  vertical-align: middle;
  color:black;
  // font-weight:bold
}
.notify-toast{
  background-color: #277df6;
  color: white;
  border-radius: 30px;
  height: 3rem !important;
  font-size: 16px !important;
}
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
@media screen and (width: 1366px) {
  .full-width{
    width: 1300px;
  }
}
@media screen and (width: 1920px) {
  .full-width{
    width: 1860px;
  }
}
.vue-tags-input ::placeholder{
  font-size: .85rem;
  color: rgba(0,0,0,.4);

}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  font-size: 15px;
}
.vs-table--tbody-table .tr-values.selected {
  font-size: 12px;
}
.vs-con-table .vs-con-tbody{
  border:none !important;
  z-index: 1;
  max-height: 275px;
  // min-width: 1350px;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td{
  padding: 0 15px !important;
  height: 40px !important;
}
.vs-con-thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  z-index: 5;
  position: fixed;
}
.vs-table--thead th{
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}
.vs-input--input.normal{
  height: 35px;
}
.ti-input{
  border-radius: 5px;
}
.vs-inputx vs-input--input normal {
  border-radius: 10px;
}
@media (max-width: 1366px) {
.manager-keyword{
  margin-left: 5px;
}
}
</style>

